// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__T3GZO","radioRow":"SimpleQuestionBuilderModal_radioRow__5FlaG"};